export default __webpack_public_path__ + "static/sy-ffadea3bef6581da2ab3b6278ee298c4.svg";